import axios from '@/helpers/axios';

export function getDoctorCreditsHistory(data) {
  return axios.post('/dealer/transactions/list', data).then(({ data }) => {
    return {
      history: data.results,
      count: data.count,
    };
  });
}

export function getPacks() {
  return axios.post('/dealer/transactions/packs', {}).then(({ data }) => {
    return data.results;
  });
}

export function buyPack(id) {
  return axios
    .post('/dealer/transactions/top-up', {
      packId: id,
      paymentToken: 'tok_us',
    })
    .then(({ data }) => {
      return data.transaction;
    });
}

export function sendCredits({ doctorId, amount }) {
  return axios
    .post('/dealer/transactions/create', {
      transaction: {
        destinationId: doctorId,
        credits: amount,
      },
    })
    .then(({ data }) => {
      return data.transaction;
    });
}
